import 'dayjs/locale/de';

import dayjs from 'dayjs';
import type { Dates as DateType } from 'types/capi/shared';

export function getCurrentDateUnix() {
  return Math.floor(Date.now() / 1000);
}

export function formatReleaseDateShort(
  unixTimestamp: number,
  locale: string = 'en'
) {
  return dayjs(unixTimestamp * 1000)
    .locale(locale)
    .format('ddd DD MMM');
}

export function formatReleaseDate(
  unixTimestamp: number,
  locale: string = 'en'
) {
  return dayjs(unixTimestamp * 1000)
    .locale(locale)
    .format('ddd DD MMM YY');
}

export function formatReleaseDateLong(
  unixTimestamp: number,
  locale: string = 'en'
) {
  return dayjs(unixTimestamp * 1000)
    .locale(locale)
    .format('ddd DD MMM YY hh:mm A');
}

export function formatRaffleDate(unixTimestamp: number, locale: string = 'en') {
  return dayjs(unixTimestamp * 1000)
    .locale(locale)
    .format('D MMM ha');
}

export const formatReleaseDateLarge = (
  unixTimestamp: number,
  locale: string = 'en'
) => {
  let ts = unixTimestamp * 1000;

  return (
    dayjs(ts).locale(locale).format('ddd DD MMM') +
    ' at ' +
    dayjs(ts).locale(locale).format('hh:mm a').toUpperCase()
  );
};

export function formatArticleDate(
  { date }: { date: DateType },
  locale: string = 'en'
) {
  return dayjs(Number(`${date.modified ?? date.published}`) * 1000)
    .locale(locale)
    .format('DD MMM, YYYY h:mm A');
}
